export default __webpack_public_path__ + "static/media/V375_SOV.4314fae1.pdf";